/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable array-callback-return */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import InfiniteScroll from 'react-infinite-scroll-component';
import ContentItem from '../../components/ContentItem';
import ContentItemWide from '../../components/ContentItemWide';

class MyView extends Component {
  state = {
    gotoPage: 1,
    dataList: [],
    listIng: [],
    listEnd: [],
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData(1);
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getData = async (gotoPage) => {
    const { loginId } = this.props;
    const { listIng, listEnd } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getDataApi(gotoPage);
      const intReturn = result.data[0].intReturn;
      const pageCount = result.data[0].pageCount;
      const con = result.data[0].con;
      const dataList = result.data[0].listData;

      //const listEnd

      //console.log(con)
      //console.log(pageCount)
      if (intReturn === 0) {
        dataList.map((item, index) => {
          if (item.gubun === 3) {
            if (item.contentPartSerial === item.endContentPartSerial) {
              listEnd.push(item);
            } else {
              listIng.push(item);
            }
          } else {
            if (item.contentPartSerial <= item.endContentPartSerial) {
              listIng.push(item);
            } else {
              listEnd.push(item);
            }
          }
        });

        ////console.log(listIng)
        ////console.log(listEnd)
        if (this._isMounted) {
          if (con > 0) {
            //console.log('con > 0')
            this.setState({
              gotoPage: gotoPage + 1,
              con: con,
              dataList:
                gotoPage === 1
                  ? dataList
                  : this.state.dataList.concat(dataList),
              listIng: listIng,
              listEnd: listEnd,
              hasMore: pageCount < gotoPage ? false : true,
            });
          } else {
            //console.log('con < 0')
            this.setState({
              gotoPage: 1,
              con: con,
              searchList: dataList,
              listIng: listIng,
              listEnd: listEnd,
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        }
      } else {
        if (this._isMounted) {
          //console.log('intReturn <> 0')
          this.setState({
            gotoPage: 1,
            con: con,
            dataList: [],
            listIng: [],
            listEnd: [],
            hasMore: pageCount < gotoPage ? false : true,
          });
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/myView',
        {
          params: {
            userid: loginId,
            authId: authId,
            gotoPage: gotoPage,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _renderEndItem = () => {
    const { listEnd } = this.state;
    const list = listEnd.map((item, index) => {
      return (
        <div key={index} style={{ display: 'inline-block' }}>
          <ContentItem
            refer={'sametime'}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            onInit={this._getData}
            contentPartSerial={item.contentPartSerial}
          />
        </div>
        /*
                <div className="div_li">
                    <div className="dataList_img_bg"><img src="/img/test_img8.png"/></div>
                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                </div>
                */
      );
    });

    return list;
  };
  _renderIngItem = () => {
    const { listIng } = this.state;

    const list = listIng.map((item, index) => {
      return (
        <div key={index} style={{ display: 'inline-block' }}>
          <ContentItemWide
            refer={'view'}
            title={item.title}
            subTitle={item.subTitle}
            img={item.img1}
            overImg={item.overImg}
            contentSerial={item.contentSerial}
            contentPartSerial={item.contentPartSerial}
            subPartSerial2={item.subPartSerial2}
            subPartSerial3={item.subPartSerial3}
            lastContentPartSerial={item.endContentPartSerial}
            pos={item.pos}
            mediaTime={item.mediaTime}
            dRank={item.dRank}
            opening={item.opening}
            part={item.part}
            wishFlag={item.wishFlag}
          />
        </div>
      );
    });

    return list;
  };
  /*
    _onAllDelete = () => {
        const { dataList } = this.state;
        if(dataList.length <= 0) {
            toast.warn('삭제할 작품이 존재하지 안습니다.')
            return; 
        } 

        confirmAlert({ 
            title: '찜하기 전체 삭제',
            message: '찜해놓은 모든 작품을 삭제하시겠습니까? 삭제된 데이터는 복구 되지 않습니다.',
            buttons: [
              
              {
                label: '모두 삭제',
                onClick: async () => {
                    const result = await this._onAllDeleteApi();
                    const intReturn = result.data[0].intReturn;

                    if(intReturn === 0) {
                        toast.success('찜한 작품이 모두 삭제 되었습니다.');
                        this._getData(1)
                    } else {
                        toast.warn('삭제할 작품이 존재하지 안습니다.')
                    }
                }
              },
              
              {
                label: '취소',
                //onClick: () => alert('Click No')
              }
            ]
        });
    }
    */
  _onAllDeleteApi = () => {
    const { apiUrl, loginId, authId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/myZzimAllDel',
        {
          params: {
            userid: loginId,
            authId: authId,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun) => {
    const { gotoPage } = this.state;
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 0) {
        this._getData(gotoPage);
      } else if (gubun === 1) {
        this._onAllDelete();
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };

  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };

  render() {
    // const { tabIndex } = this.props.childProps;
    const { hasMore, gotoPage, listIng, listEnd } = this.state;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="mypage_content">
          <div className="mypage_group">
            <h1>
              관람 중인 작품<span>({listIng.length})</span>
              <div></div>
            </h1>
            <div className="main_list_goup1">
              <div className="div_ul">
                <InfiniteScroll
                  dataLength={this.state.listEnd.length}
                  next={() => this._getData(gotoPage)}
                  hasMore={hasMore}
                  loader={
                    <div className="vod_loading">
                      <img src={imgUrl + '/img/vod/vod_loading.png'} />
                    </div>
                  }
                  endMessage={<p style={{ textAlign: 'center' }}></p>}
                  style={{ overflow: 'hidden', textAlign: 'center' }}
                >
                  {listEnd ? this._renderIngItem() : null}
                </InfiniteScroll>
                {/*
                                <div className="div_li">
                                    <div className="list_img_bg"><img src="img/test_img5.png"/><div className="line_div"><div style={{width: '50%', height: '100%'}}></div></div></div>
                                    <div className="mypage_list_data">2020.07.29 17:00 예약</div>
                                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                                </div>
                                <div className="div_li">
                                    <div className="list_img_bg"><img src="img/test_img5.png"/><div className="line_div"><div style={{width: '50%', height: '100%'}}></div></div></div>
                                    <div className="mypage_list_data">2020.07.29 17:00 예약</div>
                                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                                </div>
                                */}
              </div>
              <div className="clear"></div>
            </div>

            <div className="height_40"></div>

            <h1>
              관람 완료 작품<span>({listEnd.length})</span>
              <div></div>
            </h1>
            <div className="main_list_goup1">
              <div className="div_ul">
                <InfiniteScroll
                  dataLength={this.state.listEnd.length}
                  next={() => this._getData(gotoPage)}
                  hasMore={hasMore}
                  loader={
                    <div className="vod_loading">
                      <img src={imgUrl + '/img/vod/vod_loading.png'} />
                    </div>
                  }
                  endMessage={<p style={{ textAlign: 'center' }}></p>}
                  style={{ overflow: 'hidden', textAlign: 'center' }}
                >
                  {listEnd ? this._renderEndItem() : null}
                </InfiniteScroll>
                {/*
                                <div className="div_li">
                                    <div className="list_img_bg"><img src="img/test_img8.png"/></div>
                                    <div className="mypage_list_data">2020.07.29 17:00 예약</div>
                                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                                </div>
                                <div className="div_li">
                                    <div className="list_img_bg"><img src="img/test_img8.png"/></div>
                                    <div className="mypage_list_data">2020.07.29 17:00 예약</div>
                                    <p>카구야님은 고백받고 싶어 ~ <span>제2화. 녀석들이 미워</span></p>
                                </div>
                                */}
              </div>
              <div className="clear"></div>
            </div>
          </div>
        </div>
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyView));
